<template>
    <b-modal
        v-model="mostrarModalEvento"
        @show="preencher()"
        @hide="fecharModal()"
        @close="fecharModal()">
        <div slot="modal-title">
            Evento -
            <b-badge variant="warning">{{ operacaoProp }}</b-badge>
        </div>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Nome do Evento</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="nomeEvento"
                        ></b-form-input>
                        <b-form-invalid-feedback> O nome é Obrigatório </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Código do Evento</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            v-model="codEvento"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        operacao: {
            type: String,
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        evento: {
            type: Object,
            default: () => {}
        },

        acao: {
            type: Object,
            default: () => {}
        },

        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        nomeEvento: {
            required
        }
    },

    data() {
        return {
            mostrarModalEvento: false,
            codEvento: null,
            nomeEvento: null,
            idEvento: null,
            operacaoProp: 'INSERÇÃO'
        }
    },

    methods: {
        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar() {
            this.mostrarModalEvento = false
            this.nomeEvento = null
            this.codEvento = null
            this.idEvento = null
        },

        preencher() {
            if (this.operacao == 'A') {
                this.nomeEvento = this.evento.nomeEvento
                this.codEvento = this.evento.codEvento
                this.idEvento = this.evento.idEvento
            }
        },

        salvar() {
            let eventoDto = {
                nomeEvento: this.nomeEvento,
                codEvento: this.codEvento,
                idEvento: this.idEvento,
                idAcaoPlanoTrabalho: this.acao.idAcaoPlanoTrabalho
            }
            this.$emit('salvar', eventoDto)
            this.resetar()
        },
    },

    watch: {
        mostrarModal() {
            this.mostrarModalEvento = this.mostrarModal
            if (this.operacao == 'A') {
                this.operacaoProp = 'ATUALIZAÇÃO' 
            }
        },
    },
}
</script>
